export class generateotprequest {
    emailAddress: string;
    mobileNumber?: string;
    firstname: string;
    lastname: string;
    dateOfBirth?: string;
    otpUuid: string;

    constructor(

        emailAddress: string = "",
        mobileNumber: string = "",
        firstname: string = "",
        lastname: string = "",
       dateOfBirth: string = "",
        otpUuid:string ="",
    ) { 

        this.emailAddress = emailAddress;
        this.mobileNumber = mobileNumber;
        this.firstname = firstname;
        this.lastname = lastname;
        this.dateOfBirth = dateOfBirth;
        this.otpUuid =otpUuid;
    }

    static fromJson(json: any): generateotprequest {
        return new generateotprequest(
            json.emailAddress,
            json.mobileNumber,
            json.firstname,
            json.lastname,
            json.dateOfBirth,
            json.otpUuid,
        );
    }
}

export interface GenerateOtpResponse {
  otpUuid: string;  
}

export interface ValidateOtpRequest {
  otp: string;
  otpUuid: string;
}